import {isLoggedIn} from '../../utils/auth'
// import {injectReducer} from '../../store/reducers'

export default (store) => ({
  path: 'cross-channel-analysis',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const CrossChannelAnalysis = require('./containers/CrossChannelAnalysis').default
      // injectReducer(store, {key: 'customerDetails', reducer: customerDetailsReducer})

      cb(null, CrossChannelAnalysis)
      /* Webpack named bundle   */
    }, 'crossChannelAnalysis')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CrossChannelAnalysis/index.js